'use client'

import React from 'react'
import { Page } from '@/payload-types'
import { Blocks, HomeHero } from '@/components'
import { useAtomValue } from 'jotai'
import { tenantAtom } from '@/store/global'

interface HomeMainProps {
  page: Page
}

function HomeMain({ page }: Readonly<HomeMainProps>) {
  const tenant = useAtomValue(tenantAtom)
  const { title, lead, blocks } = page

  return (
    <main className="flex-1 flex flex-col gap-4 mt-12">
      <HomeHero title={title} lead={lead} overline={tenant?.name} />
      {blocks && <Blocks blocks={blocks} />}
    </main>
  )
}

export { HomeMain }
